let _ = t => t,
  _t,
  _t2;
import styledWithTheme from 'foundations-theming/utils';
import { MediaObject } from 'foundations-components/transitional/components/MediaObject';
import { Flex } from 'foundations-components/components/Flex';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import ContactAvatar from './ContactAvatar';
import TicketName from './TicketName';
import ContactInformation from './ContactInformation';
import TicketInformation from './TicketInformation';
import { getContactLink, getCompanyLink } from '../../../external-urls/public';
import { getTicketId } from 'svh-tickets-lib/tickets/public/operators';
import { getTicketRecordLink } from '../operators/getTicketRecordLink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TicketHeaderTextWrapper = styledWithTheme(TFlex)(_t || (_t = _`
  line-height: 16px;
  font-size: 14px;
`));
const DetailHeaderWrapper = styledWithTheme.div(_t2 || (_t2 = _`
  height: 60px;
  border-bottom: solid 1px ${0};
  background-color: ${0};
  z-index: 1;

  /* prevents vertical shrink on load issue */
  flex-shrink: 0;
`), ({
  theme
}) => theme.color['border-core-subtle'], ({
  theme
}) => theme.color['fill-surface-default']);
const TicketHeader = ({
  children,
  contactEmail,
  contactDetail,
  company,
  associatedCompanyId,
  associatedCompanyName,
  isKnownContact,
  includeEschref,
  ticket,
  threadId,
  vid,
  trackEvent,
  renderAssociateContactButton
}) => {
  const stripCompanyName = companyName => {
    return companyName.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
  };
  const shouldMatchCompany = associatedCompanyId && stripCompanyName(company) === stripCompanyName(associatedCompanyName) || company === '' && associatedCompanyName !== '';
  const companyLink = shouldMatchCompany ? getCompanyLink(associatedCompanyId) : '';
  const contactLink = getContactLink(vid);
  return (
    /*#__PURE__*/
    /* @bend-expect trellis-tokenized */
    _jsxs(DetailHeaderWrapper, {
      role: "heading",
      "aria-level": 1,
      className: "display-flex p-x-4 p-y-2",
      children: [/*#__PURE__*/_jsx(Box, {
        shrink: 0,
        marginInlineEnd: "300",
        marginBlock: "100",
        children: /*#__PURE__*/_jsx(ContactAvatar, {
          isKnownContact: isKnownContact,
          email: contactEmail,
          contactDetail: contactDetail,
          vid: vid,
          threadId: threadId
        })
      }), /*#__PURE__*/_jsx(Box, {
        basis: "100%",
        grow: 1,
        paddingInlineEnd: "600",
        children: /*#__PURE__*/_jsx(MediaObject, {
          inlineSize: "fit-content",
          children: /*#__PURE__*/_jsxs(TFlex, {
            flexDirection: "column",
            children: [/*#__PURE__*/_jsx(TFlex, {
              children: /*#__PURE__*/_jsx(TicketName, {
                includeEschref: includeEschref,
                ticketId: getTicketId(ticket),
                ticketName: ticket.defaultProperties.subject.value,
                ticketRecordLink: getTicketRecordLink(ticket),
                trackEvent: trackEvent,
                useFlex: true
              })
            }), /*#__PURE__*/_jsxs(TFlex, {
              flexDirection: "row",
              paddingBlockStart: "100",
              children: [/*#__PURE__*/_jsx(TicketHeaderTextWrapper, {
                children: /*#__PURE__*/_jsx(ContactInformation, {
                  associatedCompanyId: associatedCompanyId,
                  contactDetail: contactDetail,
                  contactLink: contactLink,
                  companyName: company || associatedCompanyName,
                  companyLink: companyLink,
                  includeEschref: includeEschref,
                  isKnownContact: isKnownContact,
                  renderAssociateContactButton: renderAssociateContactButton,
                  vid: vid,
                  trackEvent: trackEvent,
                  truncate: true,
                  truncateStringProps: {
                    maxWidth: '20vw'
                  }
                })
              }), /*#__PURE__*/_jsx(TicketHeaderTextWrapper, {
                children: /*#__PURE__*/_jsx(TicketInformation, {
                  ticketId: ticket.defaultProperties.hs_ticket_id.value,
                  createDate: ticket.defaultProperties.createdate.value,
                  closeDate: ticket.defaultProperties.closed_date.value,
                  trackEvent: trackEvent
                })
              })]
            })]
          })
        })
      }), /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        justifyContent: "end",
        paddingBlock: "200",
        flexShrink: 0,
        children: children
      })]
    })
  );
};
TicketHeader.displayName = 'TicketHeader';
export default TicketHeader;